import { useSelector } from "react-redux";
import useCloudinaryData from "../../../Common/hooks/useCloudinaryData";
import { getLeagueTypeId } from "../../../Common/utils/league";
import Media from "../../media";
import Profanity from "../../../Components/Profanity";

const LeagueTypeIcon = ({
  type,
  webPurifyStatus,
  showProfanityIcon = false,
  isReportFlag = false,
}) => {
  const { cloudinaryBase, envVersion, currentSeasonYear, configData } =
    useCloudinaryData();
  const mixApiState = useSelector((state) => state.mixapi);
  const isProfanityEnabled = mixApiState?.data?.conf?.ipe;

  const leagueTypeId = getLeagueTypeId(type);

  const imagePaths = configData?.imagePaths;

  const leagueTypeIconPath = imagePaths?.leagueTypeIcons;
  const leagueTypeImageParts = configData?.leagueTypeImageParts;

  const leagueTypeImageName =
    leagueTypeImageParts?.[leagueTypeId] ?? leagueTypeImageParts?.default;

  const leagueTypeIconImagePath = leagueTypeIconPath
    ?.replaceAll("<cloudinary_base_path>", cloudinaryBase)
    ?.replaceAll("<env_version>", envVersion)
    ?.replaceAll("<current_season_year>", currentSeasonYear)
    ?.replaceAll("<league_type>", leagueTypeImageName);

  return (
    <>
      <Media imgSrc={leagueTypeIconImagePath} alt={type} />
      {isReportFlag ? (
        <div className="si-league__card-icon si-report">
          <i className="f1i-error"></i>
        </div>
      ) : showProfanityIcon && isProfanityEnabled && webPurifyStatus ? (
        <Profanity webPurifyStatus={webPurifyStatus} type="league" />
      ) : null}
    </>
  );
};

export default LeagueTypeIcon;
